import http from '@/http';
import axios from 'axios';


export default class PermissaoService {

	getMenuUsuario(idusuario, processo){
		return this.montaMenu(idusuario, processo);
	}

	async montaMenu(idusuario, processo){

		let menuUsuario = [{
					label: 'Processo em Andamento', icon: 'pi pi-fw pi-home',
					items: []
				},
				{
					label: 'Cadastros Básicos', icon: 'pi pi-fw pi-home',
					items: []
				},
				{
					label: '', icon: '',
					items: []
				}
			];

		if(idusuario && processo){
			let acessos = await http.get(`auth/permissoes/usuario/${idusuario}`)
				.then(resposta => {
					// console.log("Resposta Acesso", resposta);
					return resposta.data;
				})
				.catch(()=>{
					localStorage.clear();
					window.location.reload();
				}
			);
			let recursos = await axios.get('/assets/data/recursos.json').then(resposta => resposta.data.data);
			// console.log('acessos', acessos);
			// console.log('Permissao Service', processo);
			// console.log(processo, processo.analiseDocumental);
			let prefixo = processo.tipoSelecao ? processo.tipoSelecao.cod == 1 ? 'SSE' : 'SSR' : 'SSE';
			for(let recurso of recursos){
				if (this.temPermissaoAoRecurso(recurso.codigo, acessos, prefixo)) {
					// && this.temRecursoPorModalidade(recurso.to.name, processo)) {
					recurso.disabled = this.temRecursoPorModalidade(recurso.to.name, processo);
					menuUsuario[recurso.grupoMenu].items.push(recurso);
				}
			}

			menuUsuario[2].items.push({label: 'Sair', icon: 'pi pi-fw pi-sign-out', to: '/' });
		}
		return menuUsuario;
	}

	temRecursoPorModalidade(recursoNome, processo) {
		// let recursos = ["distribuicao", "cartao", "notas", "resultado"];
		// let isAnaliseDocumental = (processo.analiseDocumental != undefined) && processo.analiseDocumental;
		// return isAnaliseDocumental && recursos.includes(recursoNome);
		return false;
	}

	temPermissaoAoRecurso(codigo, acessos, prefixo){
		for(let acesso of acessos){
			for(let recursoPerfil of acesso.recursoPerfils){
				// console.log(recursoPerfil.recurso.cod_recurso, codigo);
				if (codigo.includes(recursoPerfil.recurso.cod_recurso) && (recursoPerfil.recurso.cod_recurso.indexOf(prefixo) == 0)){
					return true;
				}
			}
		}
	}

}
